import { BatSilhouette, WitchSilhouette } from "./Silhouettes";

/** A witch and two bats crossing behind the nav every 30s. Hidden under reduced motion. */
export const HeaderFlyover = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 motion-reduce:hidden">
    <div className="animate-witch-flight absolute top-2.5 -left-18 h-6 w-20">
      <div className="animate-witch-bob absolute inset-0">
        <WitchSilhouette width={40} height={26} className="absolute top-0 left-6" />
        <div className="animate-bat-a absolute top-2 left-9">
          <BatSilhouette width={12} height={6} className="animate-bat-flap" />
        </div>
        <div className="animate-bat-b absolute top-2 left-9">
          <BatSilhouette width={10} height={5} className="animate-bat-flap" />
        </div>
      </div>
    </div>
  </div>
);
